import { TikTokEvent, TiktokParams } from '../../entities';
import { TikTokService } from '../../interfaces';

export class TikTokServiceDecorator implements TikTokService {
  constructor(protected readonly tikTokService: TikTokService) {}

  track(eventName: TikTokEvent, params?: TiktokParams) {
    return this.tikTokService.track(eventName, params);
  }

  isTtqRequired(): boolean {
    return this.tikTokService.isTtqRequired();
  }

  isTtqAvailable(): boolean {
    return this.tikTokService.isTtqAvailable();
  }
}
